<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
#app{
  width: 100%;
  font-family: 'pingFangSC-Regular';
}
</style>



// WEBPACK FOOTER //
// src/App.vue